module.exports = __webpack_public_path__ + "static/media/0039.b2c67b43.jpg";